import { useBrandingTheme } from '@/hooks/stores/useBrandingTheme';
import { ThemedIcon } from '@/types/icon';
import { invertColor } from '@/utils/color';

export default function OneAccountIcon({
  width = 40,
  height = 40,
}: ThemedIcon) {
  const { brandingTheme } = useBrandingTheme();
  const brandedColor = brandingTheme.primaryColor;

  return (
    <svg width={width} height={height} viewBox="0 0 40 40" fill="none">
      <path
        d="M31.5329 4H1V4.20622V29H20.0165L31.5329 4Z"
        fill={brandedColor}
      />
      <path
        d="M9.29004 23.7148L10.2866 23.5515C11.1157 23.3625 11.3261 23.2679 11.3261 21.8244V11.5735L9.31581 11.4317V10.7185C11.6354 10.2459 13.7402 9.22773 14.9945 7.78418L15.6346 7.92596V21.8244C15.6346 23.2679 15.8236 23.3882 16.6526 23.5515L17.602 23.7148V24.3764H9.29434V23.7148H9.29004Z"
        fill={invertColor(brandedColor)}
      />
    </svg>
  );
}
